import React, { FormEvent } from 'react';
import { SearchBySplitInput } from '~/components/Form';

interface SearchUsersProps {
    dropdownItems: { val: string; label: string }[];
    onDropdownChange: (val: { val: string; label: string }) => void;
    onSubmit: (x: string) => void;
}
export function SearchUsers({ dropdownItems, onDropdownChange, onSubmit }: SearchUsersProps) {
    const [userSearch, setUserSearch] = React.useState('');

    function handleSubmit(event: FormEvent) {
        event.preventDefault();
        onSubmit(userSearch);
    }

    return (
        <form onSubmit={handleSubmit}>
            <SearchBySplitInput
                dropdownId="search-users-by-field"
                inputId="user_search"
                dropdownItems={dropdownItems}
                onDropdownChange={onDropdownChange}
                onInputChange={(e) => setUserSearch((e.target as HTMLInputElement).value)}
            />
        </form>
    );
}
